import { Row, Col, Modal, Form, Input } from "antd";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import StateSelect from "../../components/select/StateSelect";
import CitySelect from "../../components/select/CitySelect";

const From = ({ path, sectionName, show, hide, data, refresh }) => {

  const [form]                          =   Form.useForm();
  const { request }                     =   useRequest();
  const [loading, setLoading]           =   useState(false);
  const [phoneNumber, setPhoneNumber]   =   useState({ phone: '', country_code: '' });
  const [selectedState, setSelectedState] = useState(null);

  const handleChange = (value = '', data = {}) => {
    const country_code = data?.dialCode || '';
    const phone = value ? value.replace(country_code, '') : '';
    setPhoneNumber({ country_code, phone });
  };

  useEffect(() => {
    if (!data) return;

    const stateId = data.state?._id || data.state || undefined;
    const cityId  = data.city?._id  || data.city  || undefined;

    form.setFieldsValue({
      ...data,
      state : stateId,
      city  : cityId,
    });

    setSelectedState(stateId || null);
    setPhoneNumber({
      phone        : data?.phone        || '',
      country_code : data?.country_code || '',
    });
  }, [data]);

  const handleStateChange = (stateId) => {
    setSelectedState(stateId);
    form.setFieldValue('city', undefined);
  };

  const onCreate = (values) => {
    if (!phoneNumber.phone) return ShowToast('Please enter phone number', Severty.ERROR);

    if (phoneNumber.phone.length < 8 || phoneNumber.phone.length > 12) {
      return ShowToast('Phone number should be between 8 to 12 digits', Severty.ERROR);
    }

    const payload = {
      ...values,
      phone        : phoneNumber.phone,
      country_code : phoneNumber.country_code,
    };

    setLoading(true);
    request({
      url: `${data ? path + "/" + data._id : path}`,
      method: 'POST',
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      width={1000}
      open={show}
      title={`${data ? 'Update ' + sectionName : 'Create a New ' + sectionName}`}
      okText={data ? "Update User" : "Create User"}
      onCancel={hide}
      okButtonProps={{
        form: 'create',
        htmlType: 'submit',
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row gutter={[16, 16]}>

          <Col span={24} xs={12} sm={12} md={8}>
            <Form.Item className="mb-0"
              label="Firm Name"
              name="firm_name"
              normalize={value => value.trimStart()}
              rules={[
                { max: 255, message: "Firm name should not contain more than 255 characters!" },
              ]}
            >
              <Input autoComplete="off" placeholder="Enter Firm Name" />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={8}>
            <Form.Item className="mb-0"
              label="Contact Person"
              name="name"
              normalize={value => value.trimStart()}
              rules={[
                { max: 255, message: "Name should not contain more than 255 characters!" },
                { min: 2, message: "Name should contain at least 2 characters!" },
                { pattern: new RegExp(/^[a-zA-Z ]*$/), message: "Only Alphabetic Characters Allowed!" },
              ]}
            >
              <Input autoComplete="off" placeholder="Enter Contact Person Name" />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={8} className="flagMobileNumber">
            <Form.Item className="mb-0" required={true} label="Contact Number">
              <PhoneInput
                inputProps={{
                  name: "phone",
                  required: true,
                  autoFocus: false,
                  placeholder: "Enter Contact Number",
                }}
                isValid={(value, country) => {
                  if (value.match(/1234/)) {
                    return 'Invalid value: ' + value + ', ' + country.name;
                  }
                  return true;
                }}
                country={"in"}
                value={`${phoneNumber.country_code}${phoneNumber.phone}`}
                onChange={handleChange}
              />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={8}>
            <Form.Item className="mb-0"
              label="Email Address"
              name="email"
              rules={[
                { type: 'email', message: 'The email is not a valid email!' },
                { max: 100, message: "Email should not contain more than 100 characters!" },
                {
                  pattern: new RegExp(/^([a-zA-Z0-9._%-]*[a-zA-Z]+[a-zA-Z0-9._%-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/),
                  message: "Enter valid email!",
                },
              ]}
            >
              <Input autoComplete="off" placeholder="Enter Email Address" />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={8}>
            <Form.Item className="mb-0"
              label="Address 1"
              name="address_line_1"
              normalize={value => value.trimStart()}
            >
              <Input autoComplete="off" placeholder="Enter Address Line 1" />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={8}>
            <Form.Item className="mb-0"
              label="Address 2"
              name="address_line_2"
              normalize={value => value.trimStart()}
            >
              <Input autoComplete="off" placeholder="Enter Address Line 2" />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={8}>
            <Form.Item className="mb-0"
              label="Area"
              name="area"
              normalize={value => value.trimStart()}
            >
              <Input autoComplete="off" placeholder="Enter Area" />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={8}>
            <Form.Item className="mb-0" label="State" name="state">
              <StateSelect onChange={handleStateChange} />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={8}>
            <Form.Item className="mb-0" label="City" name="city">
              <CitySelect stateId={selectedState} />
            </Form.Item>
          </Col>

        </Row>
      </Form>
    </Modal>
  );
};

export default From;
